import { todayKey } from "@/lib/time";

export const SAMPLE_PREFIX = "TSAMPLE";

const HEAD = [
  "Operator,Client Name,Phone,Date,P/U,Appt,P/U Address/Entrance,P/U,Drop             ,Drop,Miles,Fare,Trip,Veh,StandingOrder ,Escort,Trip Num,Shared,Outbound,OneWay,Comments",
  ", , , ,Time,Time,Dr/Prog            ,City,Address/Entrance,City,     ,    ,Type,Typ,Id             ,      ,        ,Group ,         ,     ,        ",
];

// Fictional riders and public landmark addresses only
const ROWS = [
  ["SAMPLE,RIDER ONE", "0730A", "0800A", ",1,CITY HALL SQ,,02201", "BOSTON", ",55,FRUIT ST,,02114", "BOSTON", 2, 23, "D", "OUTBOUND", "CN"],
  ["SAMPLE,RIDER ONE", "1100A", "0000A", ",55,FRUIT ST,,02114", "BOSTON", ",1,CITY HALL SQ,,02201", "BOSTON", 2, 23, "D", "INBOUND", "CN"],
  ["SAMPLE,RIDER TWO", "0845A", "0915A", ",700,BOYLSTON ST,,02116", "BOSTON", ",330,BROOKLINE AVE,,02215", "BOSTON", 3, 24.5, "W", "OUTBOUND", "WC"],
  ["SAMPLE,RIDER TWO", "0130P", "0000A", ",330,BROOKLINE AVE,,02215", "BOSTON", ",700,BOYLSTON ST,,02116", "BOSTON", 3, 24.5, "W", "INBOUND", "WC"],
  ["SAMPLE,RIDER THREE", "1000A", "1030A", ",4,JERSEY ST,,02215", "BOSTON", ",800,WASHINGTON ST,,02111", "BOSTON", 2, 23, "D", "OUTBOUND", "CN,EL"],
];

const q = (v) => (/[",]/.test(String(v)) ? `"${String(v).replace(/"/g, '""')}"` : String(v));

export const buildSampleMart = () => {
  const [y, m, d] = todayKey().split("-").map(Number);
  const next = new Date(Date.UTC(y, m - 1, d + 1));
  const date = `${next.getUTCMonth() + 1}/${next.getUTCDate()}/${next.getUTCFullYear()}`;
  const lines = [`From:${date} To:${date}${",".repeat(20)}`, ...HEAD];
  ROWS.forEach(([name, pu, appt, from, fromCity, to, toCity, miles, fare, veh, dir, notes], i) => {
    const n = String(i + 1).padStart(2, "0");
    lines.push(["DTSV~CSAMPLE", name, "5555550100", date, pu, appt, from, fromCity, to, toCity, miles, fare,
      "SAMPLE", veh, `RSAMPLE${n}`, 0, `${SAMPLE_PREFIX}${n}`, "", dir, "NO", notes].map(q).join(","));
  });
  return { csv: `${lines.join("\r\n")}\r\n`, filename: `DTSV_SAMPLE_${String(next.getUTCMonth() + 1).padStart(2, "0")}${String(next.getUTCDate()).padStart(2, "0")}${next.getUTCFullYear()}.CSV` };
};

export const downloadSampleMart = () => {
  const { csv, filename } = buildSampleMart();
  const url = URL.createObjectURL(new Blob([csv], { type: "text/csv" }));
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
};
